import ASAP from '../img/logos/ASAP_Program.png'
import LAMBDA from '../img/logos/lambdaschool.jpg'
import WANDR from '../img/logos/Waddell-and-Reed.png'
import INJOY from '../img/logos/InjoyLifeResources.jpeg'
import CITY from '../img/logos/GardenGrove.jpg'
import RCSMITH from '../img/logos/RCSmithDesignBuild.png'
import ANAHEIMAUTO from '../img/logos/AnaheimAutomation.png'


export const companyInfo = [
  {
    image: LAMBDA,
    company: 'Lambda School',
    companyUrl: 'https://lambdaschool.com/',
    title: 'Software Engineer',
    location: 'New York, NY',
    description: 'Upon graduation, I became eligible for Lambda School\'s Software Engineer Contract program. In this continuation program Lambda School sources contracts for their students to build real products for customers on a 1099 basis. This has allowed me to work on multiple teams, increased exposure to various technologies (Javascript, Docker, AWS, IBM Watson, Python, MongoDB, PostgreSQL, Postman, Ruby on Rails, Wordpress, Firebase) working through the full life cycle from product analysis and design to deployment and maintenance.' 
  },
  {
    image: ASAP,
    company: 'Titan Capital Management',
    companyUrl: 'https://giving.fullerton.edu/features/applied-security.aspx',
    title: 'Equity Analyst (Buy-Side)',
    location: 'Fullerton, CA',
    description: `In Titan Capital Management we managed $1.5 million of the university’s endowment fund. We conducted active management seeking to outperform the S&P 500 on an absolute basis. Our investment philosophy consisted of bottom-up fundamental analysis and technical analysis to find companies that would make attractive returns on investment. We traveled to San Francisco to visit Jackson Square Partners where I presented my buy report for Grubhub to the portfolio managers and investment analysts. Following that trip, we traveled to New York to visit the NYSE and talk to brokers on the trading floor and discuss our short report on SNAP upon their IPO.  ` 
  },
  {
    image: WANDR,
    company: 'Waddell & Reed',
    companyUrl: 'https://www.waddell.com/',
    title: 'Financial Planning and Investments Intern',
    location: 'Brea, CA',
    description: 'With Waddell and Reed, I was their intern in their month long internship program. Learning about multiple investment securities and presented them to other analysts. During this time I put together a buy presentation for Edwards Lifesciences, catalyst, investment thesis, and competitive advantage in the industry. '
  },
  {
    image: INJOY,
    company: 'Injoy Life Resources',
    companyUrl: 'https://www.injoyliferesources.com/',
    title: 'Life Coach',
    location: 'Bellflower, CA',
    description: 'Injoy Life Resources was a great company to work for that serves the special needs community. I partnered with one of their members as a life coach, taking time teaching him life skills and practicing proper behavioral skills in the community. During this process, I would track his performance over the course of the week and then have meetings with his behavioral psychologist, then make adjustments and set new goals. With all this care for his personal hygiene was also one of my top priorities and done with care and integrity. Providing a voice for this community when they can’t always advocate for themselves, has definitely become one of my passionate pursuits in life.'
  },
  {
    image: CITY,
    company: 'City of Garden Grove',
    companyUrl: 'https://ggcity.org/',
    title: 'Support Engineer',
    location: 'Garden Grove, CA',
    description: 'During my time with the City of Garden Grove, I help support over 300 employees with their IT needs to be able to conduct their day-to-day operations. Some of the major tasks that I was able to assist the IT department was creating a standard citywide desktop image, various Linux commands for user profiles such as scripting user logins, and remote session software support.'
  },
  {
    image: RCSMITH,
    company: 'RC Smith Design Build',
    companyUrl: 'https://www.rcsmithdesignbuild.com/',
    title: 'Independent Bookkeeper',
    location: 'Fullerton, CA',
    description: 'RC Smith Design Build was a great small family-owned general contracting business. My role in this operation was servicing their IT needs that consisted of computer builds, software installation, and network integration. I was also their bookkeeper and managed the flow of transactions and recorded them into their financial statements. I also put together dynamic excel templates for automated reporting. '
  },
  {
    image: ANAHEIMAUTO,
    company: 'Anaheim Automation',
    companyUrl: 'https://www.anaheimautomation.com/',
    title: 'Front-End Web Designer',
    location: 'Anaheim, CA',
    description: 'As a Web Designer, I spent most of my time making Anaheim Automation’s UI/UX provide our customers with a great user experience. I also designed a photography room to take high-quality pictures of their products and edited them in Photoshop for the website. For quality assurance, I made sure user spec sheets on the website were accurate by contacting Anaheim Automation\'s distributors and worked closely with the engineering and marketing teams for verification. Some of my major contributions consisted of coming up with filtration in the single item page view that could couple with other items that we sold, to promote cross-selling and increase sales. '
  }
];
